<template>
  <!-- eslint-disable -->
  <div class="layout" id="liveHouse">
    <div class="section">
      <div class="section_left">
        <div class="mb">
          <h2 class="tt">全台LiveHouse地圖指南
          </h2>
          <p class="tt">
            點選場館，了解更多故事與資訊！
          </p>
          <hr>
        </div>
        <div class="n_layout" style="display: none;">
          <p class="n_back" style="display: none;">返回地圖｜北部</p>
          <select class="N_button_mb" id="mySelect" style="display: none;">
            <option value="">點選場館，了解更多故事與資訊！</option>
            <option value="n1">The Wall Live House </option>
            <option value="n2">杰克音樂 </option>
            <option value="n3">河岸留言－西門紅樓展演館 </option>
            <option value="n4">公館河岸留言 </option>
            <option value="n5">Revolver </option>
            <option value="n6">Legacy Taipei傳音樂展演空間 </option>
            <option value="n7"> PIPE Live Music</option>
            <option value="n8">破牆X爛Bar </option>
            <option value="n9">凝聚力展演空間 </option>
            <option value="n10">女巫店 </option>
            <option value="n11">樂悠悠之口 光復南 </option>
            <option value="n12">三創Clapper Studio </option>
            <option value="n13">Corner House </option>
            <option value="n14">後台Backstage Cafe </option>
            <option value="n15">月見ル君想フ </option>
            <option value="n16"> Zepp New Taipei</option>
            <option value="n17">ThERE CAFÉ&LIVE HOUSE</option>
            <option value="n18">彌聲Mixing Studio</option>
            <option value="n19">江山藝改所</option>
            <option value="n20">風LiveHouse</option>
          </select>

          <div class="N_button pc" style="display: none;">
            <button id="n1">The Wall Live House </button>
            <button id="n2">杰克音樂 </button>
            <button id="n3">河岸留言－西門紅樓展演館 </button>
            <button id="n4">公館河岸留言 </button>
            <button id="n5">Revolver </button>
            <button id="n6">Legacy Taipei傳音樂展演空間</button>
            <button id="n7">PIPE Live Music</button>
            <button id="n8">破牆X爛Bar </button>
            <button id="n9">凝聚力展演空間 </button>
            <button id="n10">女巫店 </button>
            <button id="n11">樂悠悠之口 光復南 </button>
            <button id="n12">三創Clapper Studio </button>
            <button id="n13">Corner House </button>
            <button id="n14">後台Backstage Cafe </button>
            <button id="n15">月見ル君想フ </button>
            <button id="n16"> Zepp New Taipei</button>
            <button id="n17">ThERE CAFÉ&LIVE HOUSE</button>
            <button id="n18">彌聲Mixing Studio</button>
            <button id="n19">江山藝改所</button>
            <button id="n20">風LiveHouse</button>
          </div>

        </div>
        <div class="c_layout" style="display: none;">
          <p class="c_back" style="display: none;">返回地圖｜中部</p>
          <select class="c_button_mb" id="mySelect2" style="display: none;">
            <option value="">點選場館，了解更多故事與資訊！</option>
            <option value="c1"> Legacy Taichung 傳 音樂展演空間</option>
            <option value="c2">玩劇島小劇場</option>
            <option value="c3"> 迴響音樂藝文展演空間</option>
            <option value="c4"> 福大祿昌文藝展演空間</option>
          </select>
          <div class="c_button pc" style="display: none;">
            <button id="c1"> Legacy Taichung 傳 音樂展演空間</button>
            <button id="c2">玩劇島小劇場</button>
            <button id="c3"> 迴響音樂藝文展演空間</button>
            <button id="c4"> 福大祿昌文藝展演空間</button>
          </div>
        </div>

        <div class="s_layout" style="display: none;">
          <p class="s_back" style="display: none;">返回地圖｜南部</p>
          <select class="s_button_mb" id="mySelect3" style="display: none;">
            <option value="">點選場館，了解更多故事與資訊！</option>
            <option value="s1">TCRC Livehouse</option>
            <option value="s2">Seety新城視 展演空間</option>
            <option value="s3">LIVE WAREHOUSE</option>
            <option value="s4"> Rocks岩石音樂</option>
            <option value="s5">後台 Backstage Live</option>
            <option value="s6">Paramount Bar 《百樂門酒館》</option>
            <option value="s7">海邊的卡夫卡高流店</option>
            <option value="s8">洛克音樂藝文展演空間</option>
            <option value="s9">漂丿白鷺live house</option>
            <option value="s10">屏東B1music</option>
          </select>
          <div class="s_button" style="display: none;">
            <button id="s1">TCRC Livehouse</button>
            <button id="s2">Seety新城視 展演空間</button>
            <button id="s3">LIVE WAREHOUSE</button>
            <button id="s4"> Rocks岩石音樂</button>
            <button id="s5">後台 Backstage Live</button>
            <button id="s6">Paramount Bar 《百樂門酒館》</button>
            <button id="s7">海邊的卡夫卡高流店</button>
            <button id="s8">洛克音樂藝文展演空間</button>
            <button id="s9">漂丿白鷺live house</button>
            <button id="s10">屏東B1music</button>
          </div>
        </div>
        <div class="w_layout" style="display: none;">
          <p class="w_back" style="display: none;">返回地圖｜東部</p>
          <select class="w_button_mb" id="mySelect4" style="display: none;">
            <option value="">點選場館，了解更多故事與資訊！</option>
            <option value="w1">鐵花村</option>
            <option value="w2">花聲客廳</option>
          </select>
          <div class="w_button" style="display: none;">
            <button id="w1" style="width: 100%;">鐵花村</button>
            <button id="w2">花聲客廳</button>
          </div>
        </div>


        <div class="zone">
          <div class="N" id="N">
            <P>北部</P>
          </div>
          <div id="C">
            <P>中部</P>
          </div>
          <div id="S">
            <P>南部</P>
          </div>
          <div id="W">
            <P>東部</P>
          </div>
        </div>
      </div>

      <div class="section_right">
        <h2 class="pc hh">全台LiveHouse地圖指南
        </h2>
        <p class="pc hh">
          點選場館，了解更多故事與資訊！
        </p>
        <div class="n_layout">
          <div class="n1_text" style="display:none">
            <h3>The Wall Live House</h3>
            <img src="../assets/The Wall Live House.jpg" alt="The Wall Live House" loading="lazy">
            <p>
              「The Wall這牆」是歷史悠久的Live演出場域。<br>
              在當年「SCUM」、「聖界」Live House停業後，閃靈Freddy、董事長吉董、春天吶喊主辦人JIMI等人合資規畫，於2003年打造了一個新搖滾場地。<br>
              The Wall曾被《紐約雜誌》選為台北十大景點，並獲《紐約時報》、《Monocle》等國際媒體介紹報導。<br>
              身為歷久不衰的廠牌，這裡是許多樂團必朝聖之地，最早期更是有許多重金屬樂團在此茁壯。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台北市文山區羅斯福路四段200號B1
            </p>
          </div>

          <div class="n2_text" style="display:none">
            <h3>杰克音樂</h3>
            <img src="../assets/杰克音樂.jpg" alt="livehouse" loading="lazy">
            <p>「杰克音樂」是教學系統與練團室兼具的展演空間。<br>

              創辦人杰克，是亞洲爵士鼓界的「最速傳奇」，90年代有感於台灣音樂環境匱乏， 沒有完善的音樂學習及練習環境，因此於熱鬧的西門町建立此空間。<br>

              「杰克音樂」尤其重視年輕學子的發展，深耕教學並結合表演模式，培養出無數優秀人才。在此處除了可見到杰克老師的樂團「達摩樂隊」，更有多樣化的文化交流，如：ACG、地下偶像、樂團表演等。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台北市萬華區昆明街76號
            </p>
          </div>
          <div class="n3_text" style="display:none">
            <h3>河岸留言</h3>
            <img src="../assets/河岸留言.jpg" alt="livehouse" loading="lazy">
            <p>「河岸留言」為全台數一數二名聲響亮的品牌。<br>
              若將展演文化比喻為一條河，那麼河岸留言記錄了音樂人的創作軌跡，更見證了無數歌星藝人的崛起；河岸留言在2008年初出現，提供了一個能夠堅持音樂純粹的場地，更讓觀眾擁有多樣貌的表演娛樂選擇。此外河岸留言也提供「音造」課程，給予新血學習的機會。
              <br>而除了西門的「大河岸」，俗稱「小河岸」的公館河岸留言，由於都更預計將於2023年暫停營運，近期也舉辦了最後系列演出。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台北市萬華區昆明街76號
            </p>
          </div>
          <div class="n4_text" style="display:none">
            <h3>公館河岸留言</h3> <img src="../assets/公館河岸留言.jpg" alt="livehouse" loading="lazy">
            <p>河岸留言」目前分為兩個場地，一個位於西門紅樓，另一個位於公館。<br>

              河岸留言是許多音樂人的搖籃，孕育了許多藝人、樂團的誕生。而俗稱「小河岸」的公館河岸留言，由於都更預計將於2023年暫停營運，近期也舉辦了「小河23事」最後系列演出。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台北市中正區羅斯福路三段244巷2號
            </p>
          </div>
          <div class="n5_text" style="display:none">
            <h3>Revolver</h3> <img src="../assets/Revolver.jpg" alt="livehouse" loading="lazy">
            <p>「Revolver左輪手槍」自2010年開業以來，一直是台北最受歡迎的LiveHouse酒吧之一。<br>

              英籍老闆Jez當初落腳台北後，發現台灣人對夜生活的認識大多只有放著電音舞曲的夜店，因此開店初衷便是讓本地人有更多的類型選擇。<br>

              Revolver以打造獨立音樂及次文化場景為目標，店內懸掛著「No
              Coldplay」木牌，更顯示出此處強調「硬地indie」的定位，許多龐克、另類搖滾曲風都能在這裡聽見，如：BB彈、孝順一族、反正我很閒等樂團都有在此表演過，幾乎與舞台零距離的觀眾席空間，成為了樂迷們與表演者共樂的天地。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台北市中正區羅斯福路一段1-2號
            </p>
          </div>
          <div class="n6_text" style="display:none">
            <h3>Legacy Taipei傳音樂展演空間</h3> <img src="../assets/Legacy Taipei傳音樂展演空間.jpg" alt="livehouse" loading="lazy">
            <p>Legacy Taipei座落於華山1914創意文化園區內，以長型的觀眾區為空間設計，能容量千人的空間規格，也讓許多樂團將此地設為里程碑之一，期待有天能帶著滿場的觀眾人數稱霸此場館。<br>

              此外，Legacy在台北更有諸多不同容納量的展演空間，提供多樣的場館服務，如：Legacy MAX、Legacy mini @好丘、Legacy mini @amba等。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台北市中正區八德路一段1號華山1914創意文化園區中5A館
            </p>
          </div>
          <div class="n7_text" style="display:none">
            <h3>PIPE Live Music</h3> <img src="../assets/PIPE Live Music.jpg" alt="livehouse" loading="lazy">
            <p>PIPE Live Music位於河堤邊，位處台北市的邊陲地帶，提供舞台給國內外獨立音樂團體和DJ表演。場地內以水管工業風為裝潢亮點，吸引了許多年輕音樂愛好者前來欣賞表演。<br>

              此地曾舉辦禾火OUT音樂節、錄製瞎槓音樂節目，做出了許多文化記錄與貢獻。而除了樂團以外，此地更是許多嘻哈演出的所在，是各類型音樂文化交流的好去處。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台北市中正區思源街1號
            </p>
          </div>
          <div class="n8_text" style="display:none">
            <h3>破牆X爛Bar </h3> <img src="../assets/破牆X爛Bar.jpg" alt="livehouse" loading="lazy">
            <p>「爛泥發芽音樂祭」打造了自由的LIVE現場，而創辦人將沒有隔閡的精神帶到了音樂展演空間，期許打造一個任何人都能參與、創造的音樂據點，大家能一起成為破牆者。<br>
              破牆X爛Bar經常舉辦各式各樣的表演，包括搖滾、重金屬、龐克等音樂演出，更有卡拉OK等企劃。破牆X爛Bar裝潢簡樸，氛圍熱烈，舞台上的表演者充滿活力和創意，吸引許多熱愛音樂和藝術的年輕人前來參與，也是表現自我、發掘才華的舞台。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台北市中正區重慶南路三段104號
            </p>
          </div>
          <div class="n9_text" style="display:none">
            <h3>凝聚力展演空間</h3> <img src="../assets/凝聚力展演空間.jpg" alt="livehouse" loading="lazy">
            <p>凝聚力展演空間經常舉辦各類型音樂和藝術表演，提供給獨立音樂團體和表演者一個展現才華的舞台。<br>

              此處除了展演空間以外，也提供了音樂教室環境及練團室，場內的裝潢簡潔大方，更有多元的表演內容，如idol演出、發表會等空間運用。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台北市松山區八德路三段106巷1號B1
            </p>
          </div>
          <div class="n10_text" style="display:none">
            <h3>女巫店</h3> <img src="../assets/女巫店.jpg" alt="livehouse" loading="lazy">
            <p>創立於1996 年的​女巫店，是張懸、蘇打綠、陳綺貞等許多創作人的搖籃，店內主題極具特色，與人文思想息息相關。<br>

              女巫店也時常舉辦各類型活動，為台灣文化做出了貢獻，是許多獨立音樂愛好者的朝聖地之一。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台北市大安區新生南路三段56巷7號
            </p>
          </div>
          <div class="n11_text" style="display:none">
            <h3>樂悠悠之口 光復南</h3> <img src="../assets/樂悠悠之口 光復南.jpg" alt="livehouse" loading="lazy">
            <p>樂悠悠之口是位於台北東區的展演空間，鄰近大巨蛋、松山文創園區。此處也是舉辦「B Festival」音樂節的場地，深受樂迷的喜愛。<br>

              除了音樂表演外，樂悠悠之口還常舉辦戲劇、展覽、魔術等多元的演出，提供消費者許多種娛樂選擇。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台北市大安區光復南路100號B1
            </p>
          </div>
          <div class="n12_text" style="display:none">
            <h3>三創Clapper Studio</h3> <img src="../assets/三創Clapper Studio.jpg" alt="livehouse" loading="lazy">
            <p>在台北光華商圈中，「三創生活園區」5樓的展演空間「CLAPPER STUDIO」佔地165坪，挑高7米，可以容納700人站位或400個座位，是一個專業的影音展演場地。<br>

              「CLAPPER
              STUDIO」以最新科技打造，希望呈現出最專業的表演內容。它不僅具有商業價值，同時也蘊含藝術內涵。在這個空間中，身聲互動和影音結合是常見的演出形式。許多知名的表演者，像是吉他武士MIYAVI、UNISON
              SQUARE GARDEN、SiM等等，都曾在這裡演出。<br>

              「CLAPPER STUDIO」的展演內容非常多元化，以新穎的方式展現各種不同的表演形式。在這個展演空間中，觀眾可以享受最好的聲音、燈光和視效，讓他們完美地演繹出原音感動。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台北市中正區市民大道三段2號
            </p>
          </div>
          <div class="n13_text" style="display:none">
            <h3>Corner House</h3> <img src="../assets/Corner House.jpg" alt="livehouse" loading="lazy">
            <p>
              烏雲先生是角落系列的創辦人，對音樂充滿熱愛，於2013年4月創立了Ｍusic
              Corner音樂餐廳。這裡投資了千萬元打造燈光、音響、舞台等設備，每天都有現場樂團表演，成功地將美食和現場音樂演出結合在一起，帶給顧客舒適愉悅的娛樂體驗，也得到了國內外的高度關注和迴響。<br>

              由於烏雲先生本身也是樂團表演者，因此在隔年成立了Music Corner練團室，提供專業的彩排和演出場所給音樂人使用。在2015年10月，他帶領團隊打造了位於市中心附近的Corner
              House音樂展演館，創造出一個耳目一新、國際級的表演場地。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台北市南港區忠孝東路六段21號1樓
            </p>
          </div>
          <div class="n14_text" style="display:none">
            <h3>後台Backstage Cafe</h3> <img src="../assets/後台Backstage Cafe.jpg" alt="livehouse" loading="lazy">
            <p>座落在公館台大校園，為音樂而生的複合式藝文空間，是能夠與三五好友相約聚會，共同分享音樂、生活、咖啡美食的好去處，更是給予許多潛力優質創作者演出舞台的起點。<br>

              場館內同樣建構了完善且專業的舞台、燈光及音響設備，適合舉辦 100 至 300 人的音樂會、脫口秀、藝文展覽、媒體發佈會等活動，透過多元類型的演出在此發生，貫徹「生活，就是娛樂」的核心思想。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台北市大安區羅斯福路四段1號台大綜合體育館 2樓
            </p>
          </div>
          <div class="n15_text" style="display:none">
            <h3>月見ル君想フ</h3> <img src="../assets/月見ル君想フ.jpg" alt="livehouse" loading="lazy">
            <p>《月見ル君想フ》是一家餐廳和音樂周邊販售空間，地下一樓還有小型演出場所。<br>

              餐廳提供給顧客一個同時能享受音樂和美食的獨立空間，能讓顧客感受到舒適放鬆的氛圍，適合喜歡小眾音樂與美食的饕客或是想要一個自在聚會場所的人來造訪。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台北市大安區潮州街102號
            </p>
          </div>
          <!-- 新北 -->
          <div class="n16_text" style="display:none">
            <h3> Zepp New Taipei</h3> <img src="../assets/Zepp New Taipei.jpg" alt="livehouse" loading="lazy">
            <p>Zepp New Taipei是一個國際性的大型音樂展演空間，設計優雅、音響效果極佳。<br>

              這裡經常舉辦各種大小型音樂活動，吸引了許多知名樂團來此演出，也是國際藝人來台演出的首選場地之一。除了音樂展演外，場館鄰近商場，提供給音樂愛好者一個逛街去處。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>新北市新莊區新北大道四段3號8樓
            </p>
          </div>
          <div class="n17_text" style="display:none">
            <h3>ThERE CAFÉ&LIVE HOUSE</h3> <img src="../assets/ThERE CAFÉ&LIVE HOUSE.jpg" alt="livehouse"
              loading="lazy">
            <p>ThERE CAFÉ&LIVE HOUSE是一個融合咖啡館和音樂展演空間的場所。

              這裡提供了一個溫馨舒適的環境，可以享受美食和音樂的雙重饗宴，還經常舉辦大小型音樂活動和文化講座，是許多藝文愛好者的口袋名單之一。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>桃園市桃園區復興路454號B1樓
            </p>
          </div>
          <div class="n18_text" style="display:none">
            <h3>彌聲Mixing Studio</h3> <img src="../assets/彌聲Mixing Studio.jpg" alt="livehouse" loading="lazy">
            <p>"新竹的彌聲Mixing Studio，是一個專門提供音樂錄音、混音和後製服務的錄音室，其中更有辦理演出活動的空間。<br>

              這裡提供了先進的音響設備和專業工程人員，是桃竹苗的重要音樂陣地。"
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>新竹市北區林森路278號
            </p>
          </div>
          <div class="n19_text" style="display:none">
            <h3>江山藝改所</h3> <img src="../assets/江山藝改所.jpg" alt="livehouse" loading="lazy">
            <p>江山藝改所創立於2013年，是新竹市老街區的文化空間，結合了文史風貌和跨領域的藝文元素，為國內外藝術家、音樂家、創作者提供展演空間，並結合咖啡、甜點、文創小物的複合式空間。<br>

              在這裡，您可以閱讀、工作、喝咖啡、享受美食，接觸藝文、與創作者交流對話。溫雅的氛圍和豐富的文化內涵，讓您感受到靈感交流和碰撞的好地方。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>新竹市東區興達街1號
            </p>
          </div>
          <div class="n20_text" style="display:none">
            <h3>風LiveHouse</h3> <img src="../assets/風LiveHouse.jpg" alt="livehouse" loading="lazy">
            <p>風LiveHouse是新竹市的一家知名音樂演出場所，經常舉辦大小型的音樂演出和表演活動，吸引了許多熱愛音樂的觀眾前來欣賞。<br>

              整體空間設計以音樂藝文展演作為主軸，保留原有鋼樑形式，將牆面、地板與屋頂全面翻修，為新竹地區的音樂愛好者和音樂人提供了一個良好的交流平台。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>新竹市東區東大路一段1號
            </p>
          </div>
        </div>
        <div class="c_layout">
          <div class="c1_text" style="display:none">
            <h3>Legacy Taichung 傳 音樂展演空間</h3> <img src="../assets/Legacy Taichung 傳 音樂展演空間.jpg" alt="livehouse"
              loading="lazy">
            <p>
              Legacy Taichung坐落在中港交流道旁，緊鄰台中新市政生活圈的便利交通，擁有專業設備的展演空間，創造許多豐富的精彩節目。<br>

              此外，Legacy Taichung也經常舉辦各類型的音樂活動，讓音樂愛好者能夠在這裡享受音樂帶來的熱情與感動。"
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台中市西屯區安和路117號
            </p>
          </div>
          <div class="c2_text" style="display:none">
            <h3>玩劇島小劇場</h3> <img src="../assets/玩劇島小劇場.jpg" alt="livehouse" loading="lazy">
            <p>位於台中市中心的玩劇島 Little Play 是一個充滿藝術教育與表演的空間。除了經常舉辦音樂、劇場、舞蹈演出，也提供各年齡層適合參與的藝術工作坊，並以開放的精神，嘗試各種學習的可能性。<br>

              自2017年起，玩劇島小劇場就開始將黑盒子劇場注入豐富的音樂元素，打造出與大型劇院、演藝廳或咖啡廳不同的劇場空間，成為台中獨一無二的表演場地。在這裡，你可以找到充滿藝術氛圍的學習與表演環境，同時享受音樂、戲劇和舞蹈的豐富體驗。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台中市西區精明一街75號
            </p>
          </div>
          <div class="c3_text" style="display:none">
            <h3>迴響音樂藝文展演空間</h3> <img src="../assets/迴響音樂藝文展演空間.jpg" alt="livehouse" loading="lazy">
            <p>迴響音樂藝文展演空間是位於台中市的知名音樂演出場所，也是台灣樂團圈的指標性地點之一，這裡的音效設備優良，經常舉辦大小型的音樂演出和表演活動，吸引了眾多音樂愛好者的到來。<br>

              此場館也積極舉辦各類型的音樂活動和音樂教育課程，為台中地區的音樂文化發展做出了貢獻。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台中市中區中山路108號
            </p>
          </div>
          <div class="c4_text" style="display:none">
            <h3>福大祿昌文藝展演空間</h3> <img src="../assets/福大祿昌文藝展演空間.jpg" alt="livehouse" loading="lazy">
            <p>彰化的「福大祿昌文藝展演空間」，它是一個集合藝文表演、文創產業、展示與交流的場所。<br>

              這個空間提供獨立音樂、戲劇、藝文展覽、讀書會、座談會等多樣化的表演及活動，也曾邀請過多組獨立樂團，是彰化地區文化交流的重要平台之一。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>彰化縣彰化市中華路266號
            </p>
          </div>
        </div>

        <div class="s_layout">
          <div class="s1_text" style="display:none">
            <h3>TCRC Livehouse</h3> <img src="../assets/TCRC Livehouse.jpg" alt="livehouse" loading="lazy">
            <p>
              TCRC Livehouse 坐落於台南西門圓環旁的一個地下室，是獨立樂團表演的場地，更是許多音樂人到台南都會踩點的場館之一。<br>

              這個空間時常舉辦各類型的音樂演出，舞台的梁柱貼滿了樂團的歌單，儼然成為台灣獨立音樂場景的標誌重鎮。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台南市中西區西門路二段314號B1
            </p>
          </div>
          <div class="s2_text" style="display:none">
            <h3>Seety新城視 展演空間</h3> <img src="../assets/Seety新城視 展演空間.jpg" alt="livehouse" loading="lazy">
            <p>「Seety新城視展演空間」是台南一個舉辦音樂和藝文活動的場地，可容納百人以上的展演空間。<br>

              場館的空間寬敞、設備完備，營造出音樂和藝文氛圍，可運用於多種表演型態及活動展演。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台南市中西區民族路三段190號B1-2
            </p>
          </div>
          <div class="s3_text" style="display:none">
            <h3>LIVE WAREHOUSE</h3> <img src="../assets/LIVE WAREHOUSE.jpg" alt="livehouse" loading="lazy">
            <p>LIVEWARE HOUSE座落於駁二藝術特區的大義倉庫，是高雄首座千人規格專業現場演唱會空間。<br>

              蓄積海洋文化及流行音樂中心能量，為高雄在地音樂創建指標性空間，也有許多台灣獨立樂團在此發跡，持續的注入無限的音樂生命力！
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>高雄市鹽埕區大義街2之5號駁二藝術特區大義C10倉庫
            </p>
          </div>
          <div class="s4_text" style="display:none">
            <h3>Rocks岩石音樂</h3> <img src="../assets/Rocks岩石音樂.jpg" alt="livehouse" loading="lazy">
            <p>Rocks岩石音樂是高雄知名的Live House，舉辦過多場獨立音樂演出和搖滾派對，提供了一個充滿活力的音樂空間。<br>

              許多在地樂團都在這裡演出過，裡是熱血音樂人的聚集地，讓人感受到無限的音樂能量。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>高雄市鹽埕區莒光街219號B1
            </p>
          </div>
          <div class="s5_text" style="display:none">
            <h3>後台 Backstage Live</h3> <img src="../assets/後台 Backstage Live.jpg" alt="livehouse" loading="lazy">
            <p>位於高雄流行音樂中心鯨魚堤岸，緊鄰輕軌光榮碼頭站，擁有便利交通、美麗海景與在地特有的文化氛圍。<br>

              擁有能同時容納千人的寬闊展演空間，佔地275坪，挑高9米，內含
              12mx7m的舞台，無任何柱體及死角影響視野，更備有頂級燈光與音響器材設備，可因應各式音樂演出編制，或品牌發表、娛樂、文創等商業活動需求，以多樣化的靈活運用，創造現場的真實感動。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>高雄市苓雅區海邊路15-3號
            </p>
          </div>
          <div class="s6_text" style="display:none">
            <h3>Paramount Bar 《百樂門酒館》</h3> <img src="../assets/Paramount Bar 《百樂門酒館》.jpg" alt="livehouse"
              loading="lazy">
            <p>百樂門酒館是一家風格獨特的酒吧，也是高雄知名的音樂演出場地之一。裝潢營造出復古美式氛圍。在這裡除了可以品嚐美酒，還能欣賞到各式各樣的音樂演出。<br>

              此外，百樂門酒館也是獨立音樂重要場景，曾邀請到多位知名樂團及音樂人，讓音樂愛好者在這裡享受精彩的演出，老闆阿昌也是台語歌謠龐克樂團「一點生」的主唱。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>高雄市三民區民族一路70號
            </p>
          </div>

          <div class="s7_text" style="display:none">
            <h3>海邊的卡夫卡高流店</h3> <img src="../assets/海邊的卡夫卡高流店.jpg" alt="livehouse" loading="lazy">
            <p>
              1976樂團主唱阿凱經營的「海邊的卡夫卡」，是國內第一家結合展演空間、Café、唱片廠牌的藝文空間。原本位於台北公館，2022來到高雄流行音樂中心創立分店，這裡是氣質相似的人交流藝術和音樂的場所，成為思想交流的象徵。<br>

              來到這裡，你會感受到每個日期和時間都有不同的氛圍，是一個讓人能夠放鬆身心的好去處。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>高雄市鹽埕區真愛路1號1樓 (高雄流行音樂中心低音塔靠海側)
            </p>
          </div>
          <div class="s8_text" style="display:none">
            <h3>洛克音樂藝文展演空間</h3> <img src="../assets/洛克音樂藝文展演空間.jpg" alt="livehouse" loading="lazy">
            <p>
              創辦人洛克，當初鑒於希望高雄可以多一個室內大型的展演空間，於是成立了洛克音樂藝文展演空間（含練團室、錄音室）。<br>

              此處展演空間屬於多元化方式經營，可包場尾牙春酒、記者招待會、產品發表會、音樂演唱會...等等，現場燈光硬體樣樣俱全，也有吧台供服務，店裡可容納站位350-400人、座位220-250，展演空間挑高且無死角及梁柱，適合各式各樣類型活動。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>高雄市前金區六合二路145號B1
            </p>
          </div>
          <div class="s9_text" style="display:none">
            <h3>漂丿白鷺live house</h3> <img src="../assets/漂丿白鷺live house.jpg" alt="livehouse" loading="lazy">
            <p>
              漂丿白鷺Live House為臺南文創園區推展流行音樂工作立下一個新的里程碑，配備各種精良樂器與完備的舞台燈光音響，附近有臺南火車站的便利交通，為大臺南地區民眾提供一處絕佳的流行音樂表演或欣賞場域。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>臺南市東區北門路二段16號（1樓C區）
            </p>
          </div>
          <div class="s10_text" style="display:none">
            <h3>屏東B1music</h3> <img src="../assets/屏東B1music.jpg" alt="livehouse" loading="lazy">
            <p>
              屏東B1music是由哈雷樂團第二代團長路達瑪幹（魏金漢）所打造的小型演唱會空間，會不定期舉辦演出，傳遞屏東部落的好聲音

            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>屏東縣屏東市林森路64號B1
            </p>
          </div>
        </div>
        <div class="w_layout">
          <div class="w1_text" id="w1_text" style="display:none">
            <h3>鐵花村</h3> <img src="../assets/鐵花村.jpg" alt="livehouse" loading="lazy">
            <p>
              鐵花村是台灣東部的一個藝術創意聚落，也是舉辦音樂、展演、文化活動的場所。<br>

              這裡曾舉辦多場音樂、藝術、文化活動，更是台灣獨立樂團來到台東的聖地之一。此外，鐵花村也舉辦過多場親子、生態、戲劇等各式活動，是一個多元發展的文化聚落。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>台東縣台東市新生路135巷26號
            </p>
          </div>
          <div class="w2_text" id="w2_text" style="display:none">
            <h3>花聲客廳</h3> <img src="../assets/花聲客廳.jpg" alt="livehouse" loading="lazy">
            <p>
              花聲客廳位於花蓮鐵道文化園區一館內，提供各種聲音工作者和團體舉辦演出、講座、工作坊和各類論壇的資訊交流實驗平台。花聲客廳是咖啡廳、是酒吧、是錄音室、是live house、是音樂基地等多重複合式空間。
            </p>
            <p>
              <i class="fa-solid fa-location-dot"></i>花蓮縣花蓮市中山路71號
            </p>
          </div>
        </div>
        <div class="first_buttn">
          <a href="https://www.ftvnews.com.tw/news/detail/2023330W0268" target="_blank"> <button>
              一覽台灣LiveHouse展演空間</button></a>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSeaFEfGtN-IAvNC9zr_1A9UGKO9RS_sGWylbUCLiy3iWR1H9g/viewform"
            target="_blank"> <button> 我想推薦其他LiveHouse</button></a>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
$(document).ready(function () {

  $("#mySelect").change(function () {
    var selectedValue = $(this).val();
    for (var i = 1; i <= 21; i++) {
      var className = ".n" + i + "_text";
      if (selectedValue === "n" + i) {
        $(className).show();
      } else {
        $(className).hide();
      }
    }
  });
  $("#mySelect2").change(function () {
    var c_selectedValue = $(this).val();
    for (var j = 1; j <= 4; j++) {
      var c_className = ".c" + j + "_text";
      if (c_selectedValue === "c" + j) {
        $(c_className).show();
      } else {
        $(c_className).hide();
      }
    }
  });
  $("#mySelect3").change(function () {
    var s_selectedValue = $(this).val();
    for (var k = 1; k <= 10; k++) {
      var s_className = ".s" + k + "_text";
      if (s_selectedValue === "s" + k) {
        $(s_className).show();
      } else {
        $(s_className).hide();
      }
    }
  });
  $("#mySelect4").change(function () {
    var w_selectedValue = $(this).val();
    for (var l = 1; l <= 2; l++) {
      var w_className = ".w" + l + "_text";
      if (w_selectedValue === "w" + l) {
        $(w_className).show();
      } else {
        $(w_className).hide();
      }
    }
  });


  $('#N').click(function (e) {
    if ($(window).width() < 768) {
      if ($('.n_layout,.n_back,.N_button_mb').show()) {
        $('.zone,.hh').hide()
      }
    } else {
      if ($('.n_layout,.n_back,.N_button').show()) {
        $('.zone,.hh').hide()
      }
    }
  })

  $(window).resize(function () {
    if ($(window).width() < 768) {
      $('.N_button').hide()
      $('.N_button_mb').show()
    } else {
      $('.N_button').show()
      $('.N_button_mb').hide()
    }
  })



  $('#C').click(function (e) {
    if ($(window).width() < 768) {
      if ($('.c_layout,.c_back,.c_button_mb').show()) {
        $('.zone,.hh').hide()
      }
    } else {
      if ($('.c_layout,.c_back,.c_button').show()) {
        $('.zone').hide()
      }
    }
  })

  $(window).resize(function () {
    if ($(window).width() < 768) {
      $('.c_button').hide()
      $('.c_button_mb').show()
    } else {
      $('.c_button').show()
      $('.c_button_mb').hide()
    }
  })


  $('#W').click(function (e) {
    if ($(window).width() < 768) {
      if ($('.w_layout,.w_back,.w_button_mb').show()) {
        $('.zone,.hh').hide()
      }
    } else {
      if ($('.w_layout,.w_back,.w_button').show()) {
        $('.zone').hide()
      }
    }
  })

  $(window).resize(function () {
    if ($(window).width() < 768) {
      $('.w_button').hide()
      $('.w_button_mb').show()
    } else {
      $('.w_button').show()
      $('.w_button_mb').hide()
    }
  })



  $('#S').click(function (e) {
    if ($(window).width() < 768) {
      if ($('.s_layout,.s_back,.s_button_mb').show()) {
        $('.zone,.hh').hide()
      }
    } else {
      if ($('.s_layout,.s_back,.s_button').show()) {
        $('.zone').hide()
      }
    }
  })

  $(window).resize(function () {
    if ($(window).width() < 768) {
      $('.s_button').hide()
      $('.s_button_mb').show()
    } else {
      $('.s_button').show()
      $('.s_button_mb').hide()
    }
  })


  //北部
  $('#n1').click(function (e) {
    e.stopPropagation();
    if ($('.n1_text').show()) {
      $('.tt,.hh,.n2_text,.n3_text,.n4_text,.n5_text,.n6_text,.n7_text,.n8_text,.n9_text,.n10_text,.n11_text,.n12_text,.n13_text,.n14_text,.n15_text,.n16_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })


  $('#n2').click(function (e) {
    e.stopPropagation();
    if ($('.n2_text').show()) {
      $('.tt,.hh,.n1_text,.n3_text,.n4_text,.n5_text,.n6_text,.n7_text,.n8_text,.n9_text,.n10_text,.n11_text,.n12_text,.n13_text,.n14_text,.n15_text,.n16_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })

  $('#n3').click(function (e) {
    e.stopPropagation();
    if ($('.n3_text').show()) {
      $('.tt,.hh,.n1_text,.n2_text,.n4_text,.n5_text,.n6_text,.n7_text,.n8_text,.n9_text,.n10_text,.n11_text,.n12_text,.n13_text,.n14_text,.n15_text,.n16_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })


  $('#n4').click(function (e) {
    e.stopPropagation();
    if ($('.n4_text').show()) {
      $('.tt,.hh,.n1_text,.n3_text,.n2_text,.n5_text,.n6_text,.n7_text,.n8_text,.n9_text,.n10_text,.n11_text,.n12_text,.n13_text,.n14_text,.n15_text,.n16_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })


  $('#n5').click(function (e) {
    e.stopPropagation();
    if ($('.n5_text').show()) {
      $('.tt,.hh,.n1_text,.n3_text,.n4_text,.n2_text,.n6_text,.n7_text,.n8_text,.n9_text,.n10_text,.n11_text,.n12_text,.n13_text,.n14_text,.n15_text,.n16_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })

  $('#n6').click(function (e) {
    e.stopPropagation();
    if ($('.n6_text').show()) {
      $('.tt,.hh,.n2_text,.n3_text,.n4_text,.n5_text,.n1_text,.n7_text,.n8_text,.n9_text,.n10_text,.n11_text,.n12_text,.n13_text,.n14_text,.n15_text,.n16_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })


  $('#n7').click(function (e) {
    e.stopPropagation();
    if ($('.n7_text').show()) {
      $('.tt,.hh,.n1_text,.n3_text,.n4_text,.n5_text,.n6_text,.n2_text,.n8_text,.n9_text,.n10_text,.n11_text,.n12_text,.n13_text,.n14_text,.n15_text,.n16_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })

  $('#n8').click(function (e) {
    e.stopPropagation();
    if ($('.n8_text').show()) {
      $('.tt,.hh,.n1_text,.n2_text,.n4_text,.n5_text,.n6_text,.n7_text,.n2_text,.n9_text,.n10_text,.n11_text,.n12_text,.n13_text,.n14_text,.n15_text,.n16_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })


  $('#n9').click(function (e) {
    e.stopPropagation();
    if ($('.n9_text').show()) {
      $('.tt,.hh,.n1_text,.n3_text,.n2_text,.n5_text,.n6_text,.n7_text,.n8_text,.n2_text,.n10_text,.n11_text,.n12_text,.n13_text,.n14_text,.n15_text,.n16_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })


  $('#n10').click(function (e) {
    e.stopPropagation();
    if ($('.n10_text').show()) {
      $('.tt,.hh,.n1_text,.n3_text,.n4_text,.n2_text,.n6_text,.n7_text,.n8_text,.n9_text,.n2_text,.n11_text,.n12_text,.n13_text,.n14_text,.n15_text,.n16_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })


  $('#n11').click(function (e) {
    e.stopPropagation();
    if ($('.n11_text').show()) {
      $('.tt,.hh,.n2_text,.n3_text,.n4_text,.n5_text,.n6_text,.n7_text,.n8_text,.n9_text,.n10_text,.n1_text,.n12_text,.n13_text,.n14_text,.n15_text,.n16_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })


  $('#n12').click(function (e) {
    e.stopPropagation();
    if ($('.n12_text').show()) {
      $('.tt,.hh,.n1_text,.n3_text,.n4_text,.n5_text,.n6_text,.n7_text,.n8_text,.n9_text,.n10_text,.n11_text,.n2_text,.n13_text,.n14_text,.n15_text,.n16_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })

  $('#n13').click(function (e) {
    e.stopPropagation();
    if ($('.n13_text').show()) {
      $('.tt,.hh,.n1_text,.n2_text,.n4_text,.n5_text,.n6_text,.n7_text,.n8_text,.n9_text,.n10_text,.n11_text,.n12_text,.n2_text,.n14_text,.n15_text,.n16_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })


  $('#n14').click(function (e) {
    e.stopPropagation();
    if ($('.n14_text').show()) {
      $('.tt,.hh,.n1_text,.n3_text,.n2_text,.n5_text,.n6_text,.n7_text,.n8_text,.n9_text,.n10_text,.n11_text,.n12_text,.n13_text,.n2_text,.n15_text,.n16_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })


  $('#n15').click(function (e) {
    e.stopPropagation();
    if ($('.n15_text').show()) {
      $('.tt,.hh,.n1_text,.n3_text,.n4_text,.n2_text,.n6_text,.n7_text,.n8_text,.n9_text,.n10_text,.n11_text,.n12_text,.n13_text,.n14_text,.n2_text,.n16_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })

  $('#n16').click(function (e) {
    e.stopPropagation();
    if ($('.n16_text').show()) {
      $('.tt,.hh,.n2_text,.n3_text,.n4_text,.n5_text,.n1_text,.n7_text,.n8_text,.n9_text,.n10_text,.n11_text,.n12_text,.n13_text,.n14_text,.n15_text,.n1_text,.n17_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })


  $('#n17').click(function (e) {
    e.stopPropagation();
    if ($('.n17_text').show()) {
      $('.tt,.hh,.n1_text,.n3_text,.n4_text,.n5_text,.n6_text,.n2_text,.n8_text,.n9_text,.n10_text,.n11_text,.n12_text,.n13_text,.n14_text,.n15_text,.n16_text,.n2_text,.n18_text,.n19_text,.n20_text').hide()
    }
  })

  $('#n18').click(function (e) {
    e.stopPropagation();
    if ($('.n18_text').show()) {
      $('.tt,.hh,.n1_text,.n2_text,.n4_text,.n5_text,.n6_text,.n7_text,.n8_text,.n2_text,.n9_text,.n10_text,.n11_text,.n12_text,.n13_text,.n14_text,.n15_text,.n16_text,.n17_text,.n2_text,.n19_text,.n20_text').hide()
    }
  })


  $('#n19').click(function (e) {
    e.stopPropagation();
    if ($('.n19_text').show()) {
      $('.tt,.hh,.n1_text,.n3_text,.n2_text,.n5_text,.n6_text,.n7_text,.n8_text,.n2_text,.n10_text,.n11_text,.n12_text,.n13_text,.n14_text,.n15_text,.n16_text,.n17_text,.n18_text,.n2_text,.n20_text').hide()
    }
  })


  $('#n20').click(function (e) {
    e.stopPropagation();
    if ($('.n20_text').show()) {
      $('.tt,.hh,.n1_text,.n3_text,.n4_text,.n2_text,.n6_text,.n7_text,.n8_text,.n9_text,.n2_text,.n11_text,.n12_text,.n13_text,.n14_text,.n15_text,.n16_text,.n17_text,.n18_text,.n19_text,.n2_text').hide()
    }
  })

  //中部
  $('#c1').click(function (e) {
    e.stopPropagation();
    if ($('.c1_text').show()) {
      $('.tt,.tt,.hh,.c2_text,.c3_text,.c4_text').hide()
    }
  })

  $('#c2').click(function (e) {
    e.stopPropagation();
    if ($('.c2_text').show()) {
      $('.tt,.tt,.hh,.c1_text,.c3_text,.c4_text').hide()
    }
  })

  $('#c3').click(function (e) {
    e.stopPropagation();
    if ($('.c3_text').show()) {
      $('.tt,.tt,.hh,.c2_text,.c1_text,.c4_text').hide()
    }
  })

  $('#c4').click(function (e) {
    e.stopPropagation();
    if ($('.c4_text').show()) {
      $('.tt,.tt,.hh,.c2_text,.c3_text,.c1_text').hide()
    }
  })

  //南部
  $('#s1').click(function (e) {
    e.stopPropagation();
    if ($('.s1_text').show()) {
      $('.tt,.hh,.s2_text,.s3_text,.s4_text,.s5_text,.s6_text,.s7_text,.s8_text,.s9_text,.s10_text').hide()
    }
  })

  $('#s2').click(function (e) {
    e.stopPropagation();
    if ($('.s2_text').show()) {
      $('.tt,.hh,.s1_text,.s3_text,.s4_text,.s5_text,.s6_text,.s7_text,.s8_text,.s9_text,.s10_text').hide()
    }
  })

  $('#s3').click(function (e) {
    e.stopPropagation();
    if ($('.s3_text').show()) {
      $('.tt,.hh,.s2_text,.s1_text,.s4_text,.s5_text,.s6_text,.s7_text,.s8_text,.s9_text,.s10_text').hide()
    }
  })

  $('#s4').click(function (e) {
    e.stopPropagation();
    if ($('.s4_text').show()) {
      $('.tt,.hh,.s2_text,.s3_text,.s1_text,.s5_text,.s6_text,.s7_text,.s8_text,.s9_text,.s10_text').hide()
    }
  })

  $('#s5').click(function (e) {
    e.stopPropagation();
    if ($('.s5_text').show()) {
      $('.tt,.hh,.s2_text,.s3_text,.s4_text,.s1_text,.s6_text,.s7_text,.s8_text,.s9_text,.s10_text').hide()
    }
  })

  $('#s6').click(function (e) {
    e.stopPropagation();
    if ($('.s6_text').show()) {
      $('.tt,.hh,.s2_text,.s3_text,.s4_text,.s5_text,.s1_text,.s7_text,.s8_text,.s9_text,.s10_text').hide()
    }
  })
  $('#s7').click(function (e) {
    e.stopPropagation();
    if ($('.s7_text').show()) {
      $('.tt,.hh,.s2_text,.s3_text,.s4_text,.s5_text,.s1_text,.s6_text,.s8_text,.s9_text,.s10_text').hide()
    }
  })

  $('#s8').click(function (e) {
    e.stopPropagation();
    if ($('.s8_text').show()) {
      $('.tt,.hh,.s2_text,.s3_text,.s4_text,.s5_text,.s1_text,.s6_text,.s7_text,.s9_text,.s10_text').hide()
    }
  })

  $('#s9').click(function (e) {
    e.stopPropagation();
    if ($('.s9_text').show()) {
      $('.tt,.hh,.s2_text,.s3_text,.s4_text,.s5_text,.s1_text,.s6_text,.s7_text,.s8_text,.s10_text').hide()
    }
  })

  $('#s10').click(function (e) {
    e.stopPropagation();
    if ($('.s10_text').show()) {
      $('.tt,.hh,.s2_text,.s3_text,.s4_text,.s5_text,.s1_text,.s6_text,.s7_text,.s8_text,.s9_text').hide()
    }
  })

  //東部
  $('#w1').click(function (e) {
    e.stopPropagation();
    if ($('.w1_text').show()) {
      $('.tt,.hh,.w2_text').hide()
    }
  })
  $('#w2').click(function (e) {
    e.stopPropagation();
    if ($('.w2_text').show()) {
      $('.tt,.hh,.w1_text').hide()
    }
  })

  //回到上一頁
  $('.n_back,.w_back,.c_back,.s_back').click(function (e) {
    e.stopPropagation();
    if ($(window).width() < 768) {
      e.stopPropagation();
      if ($('.zone,.tt').show()) {
        e.stopPropagation();
        $('.N_button,.n_back,.n_layout,.w_button,.w_back,.w_layout,.s_button,.s_back,.s_layout,.c_button,.c_back,.c_layout,.N_button_mb,.hh').hide()
      }
    } else {
      if ($('.zone,.hh').show()) {
        e.stopPropagation();
        $('.N_button,.n_back,.n_layout,.w_button,.w_back,.w_layout,.s_button,.s_back,.s_layout,.c_button,.c_back,.c_layout,.N_button_m').hide()
      }
    }
  })
});

</script>
<style scoped>
select {
  padding: 0.5rem 1rem;
  margin: 0rem auto;
  display: flex;
  justify-content: center;
  font-size: 1.2rem;
  background: #EEEBE4;
  border: 2px solid black;
  letter-spacing: 0rem;
  box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
  border-radius: 20px;
  color: black;
  width: 90%
}


@media screen and (max-width:500px) {
  select {
    color: black;
    font-size: 1.2rem;
  }

}

.section_right img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  margin: auto;
  border-radius: 30px;
  border: 2px solid black;
}

.section {
  border-radius: 30px;
  border: 2px solid black;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: auto;
  max-width: 1300px;
  background-image: url('../assets/sectionbg.png');
}

.section_left {
  padding: 2rem;
  border-right: 2px solid black;
}

.section_left p {
  margin: 1rem .8rem;
  display: block;
  font-size: 1.17em;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}

/* 
.section_left button {
  margin-right: 0rem;
} */

@media screen and (max-width:768px) {
  .section {
    grid-template-columns: 1fr;
  }

  .section_left {
    padding: 0rem;
    border-right: 0px solid black;
  }

  .section_left p {
    margin: 1rem 2rem
  }

  select {
    padding: 0.5rem 1rem;
  }
}

.zone {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin: 1rem;
  height: 450px;
}


.zone div {
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border: 2px solid black;
  cursor: pointer;
}

.zone div:nth-child(1) {
  background-image: url('../assets/N.png');
}

.zone div:nth-child(2) {
  background-image: url('../assets/C.png');
}

.zone div:nth-child(3) {
  background-image: url('../assets/S.png');
}

.zone div:nth-child(4) {
  background-image: url('../assets/W.png');
}

.zone div:hover {
  opacity: .8;
  transition: .2s all;
}

.zone div p {
  font-weight: 600;
  font-size: 3rem;
  padding: 2rem 1rem;
  letter-spacing: 0.1em;
  color: #FFFFFF;
}

.zone div p :hover {
  filter: drop-shadow(0px 0px 10px rgba(255, 180, 0, 0.7));
}



.section_right {
  padding: 2rem;
  margin: auto;
}


.section_right p {
  margin: 1rem auto;
  text-align: center;
}

.mb {
  margin: 2rem auto;
  text-align: center;
}

hr {
  display: none;
}



@media screen and (max-width:768px) {
  hr {
    display: block;
    border: 1px solid black;
  }

  .section_right {
    padding: 0rem 2rem;
    margin: auto;
    margin-bottom: 2rem;
  }


  .zone {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0rem;
    margin: 1rem;
    height: 400px;
  }

  .zone div p {
    font-weight: 600;
    font-size: 2rem;
    padding: 1rem;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }

  .zone div {
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid black;
    cursor: pointer;
  }
}


.N_button {
  height: 500px;
  overflow-y: scroll;
  margin: 1rem
}

.N_button button {
  margin: .8rem auto;
}


.first_buttn {
  display: flex;
  gap: 1rem;

}


@media screen and (max-width:768px) {
  .zone {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0rem;
    margin: 2rem;
  }


  .N_button button {
    margin: 0rem auto;
  }
}


.mb {
  display: none;
}

.pc {
  display: block;
}

@media screen and (max-width:768px) {

  .mb {
    display: block;
  }

  .pc {
    display: none;
  }


}

@media screen and (max-width:500px) {

  .first_buttn {
    display: flex;
    gap: 0rem;
    flex-direction: column
  }

  button {
    margin: .5rem auto;
  }

  .section_right img {
    width: 100%;
    height: 150px;
  }

  .section_right {
    padding: 0rem 1rem;
    margin: auto;
    margin-bottom: 2rem;
  }

  .zone {
    height: 300px;
  }

  .zone div p {
    font-weight: 600;
    font-size: 2rem;
    padding: 0rem;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }

  .section_left p {
    margin: 1rem
  }

}

button {
  width: 100%;
}

.section_right div p {
  text-align: justify;
}


.n_back {
  display: block;
  font-size: 1.17em;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;

}
</style>
